module.exports = __webpack_public_path__ + "img/03.00b04ce9.png";